import { generateMnemonic, mnemonicToSeed, validateMnemonic } from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english.js';
/**
 * Das Recovery-Blatt (ADR-008).
 *
 * 12 Wörter, 128 Bit Entropie, BIP39 — ein etabliertes Verfahren mit
 * eingebauter Prüfsumme. Die Prüfsumme ist der eigentliche Gewinn gegenüber
 * einer selbstgebauten Wortliste: Wer sich beim Abtippen vertut, bekommt sofort
 * „das stimmt nicht" statt „falscher Schlüssel, alles weg".
 *
 * **Warum englische Wörter für eine deutsche Familie?** Weil BIP39 keine
 * offizielle deutsche Wortliste hat. Eine selbst zusammengestellte müsste
 * Präfix-Eindeutigkeit, Homophone und Umlaute sauber behandeln — das ist genau
 * die Art Eigenbau, die dieses Projekt vermeidet. Die englischen Wörter sind
 * kurz, eindeutig und werden abgetippt, nicht verstanden. Die UI erklärt das.
 */
export const WORT_ANZAHL = 12;
/** Erzeugt ein neues Blatt. Der Klartext existiert nur, solange er angezeigt wird. */
export function neuesRecoveryBlatt() {
    return generateMnemonic(wordlist, 128);
}
export function istGueltig(woerter) {
    return validateMnemonic(normalisiere(woerter), wordlist);
}
/**
 * Wörter → Seed. Wirft bei ungültiger Prüfsumme, statt einen unbrauchbaren
 * Schlüssel zu erzeugen — das ist der Unterschied zwischen einer verständlichen
 * Fehlermeldung und einem stillen Datenverlust.
 */
export async function zuSeed(woerter) {
    const normalisiert = normalisiere(woerter);
    if (!validateMnemonic(normalisiert, wordlist)) {
        throw new RecoveryFehler('Diese Wörter stimmen nicht. Bitte prüfe die Reihenfolge.');
    }
    return mnemonicToSeed(normalisiert);
}
export class RecoveryFehler extends Error {
}
/**
 * Toleriert, wie Menschen abtippen: Großschreibung, doppelte Leerzeichen,
 * Zeilenumbrüche vom Ausdruck, ein versehentliches Komma.
 */
export function normalisiere(eingabe) {
    return eingabe
        .toLowerCase()
        .replace(/[,;]/g, ' ')
        .trim()
        .split(/\s+/)
        .join(' ');
}
/** Für die Anzeige beim Onboarding: nummeriert, in zwei Spalten druckbar. */
export function alsListe(woerter) {
    return normalisiere(woerter).split(' ').map((wort, i) => ({ nummer: i + 1, wort }));
}
/**
 * Prüft eine einzelne Eingabe gegen die Wortliste — für die Rückmeldung
 * beim Tippen, bevor alle zwölf da sind.
 */
export function istBekanntesWort(wort) {
    return wordlist.includes(wort.trim().toLowerCase());
}
//# sourceMappingURL=recovery.js.map